import slices from './slices';

export default {
  ...slices.dateRangeSlice.actions,
  ...slices.shiftsSlice.actions,
  ...slices.scheduleUsersSlice.actions,
  ...slices.applicantsSlice.actions,
  ...slices.applicantCommentsSlice.actions,
};

export { setTemplates, setLoading, setError } from './slices/shiftTemplates';
